import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OnlineStatusService {
    private onlineStatusSubject = new BehaviorSubject<boolean>(navigator.onLine);
    onlineStatus$ = this.onlineStatusSubject.asObservable();

    constructor(private ngZone: NgZone) {
        window.addEventListener('online', () => {
            this.updateOnlineStatus(true);
        });

        window.addEventListener('offline', () => {
            this.updateOnlineStatus(false);
        });
    }

    updateOnlineStatus(isOnline: boolean) {
        this.ngZone.run(() => {
            this.onlineStatusSubject.next(isOnline);
        });
    }

    getCurrentStatus(): boolean {
        const status = navigator.onLine;
        return status;
    }

    checkStatus(): void {
        this.updateOnlineStatus(navigator.onLine);
    }
}